import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Breadcrumb from './breadcrumb/breadcrumb';

global.React = React;
global.ReactDOM = ReactDOM;
global.Breadcrumb = Breadcrumb;
global.ReactDOMServer = ReactDOMServer;
